import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import { User } from "types";
import AddDepartmentForm from "./addDepartmentForm";

type AddDepartmentProps = {
  opened: boolean;
  onClose: () => void;
};

function AddDepartment({ opened, onClose }: AddDepartmentProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add Department"
        onClose={onClose}
        ariaLabel="Close create Department modal"
      />

      <AddDepartmentForm onClose={onClose} user={{} as User} />
    </Modal>
  );
}

export default AddDepartment;
